import type { JSX } from 'react';
import { formatCount } from '../format';
import { CHRONICLE } from '../labels';
import { useChronicle } from '../useChronicle';
import { ChronicleSheet } from './ChronicleSheet';

/**
 * The site-wide chronicle trigger: "Ööpäev · N", on every route, opening the Sheet (ux-spec §4).
 *
 * The badge is absent while the window is unknown and never guesses — a placeholder count would be
 * a claim about the corpus — but a measured zero on a covered day is shown, because that is a fact.
 */
export function ChronicleButton(): JSX.Element {
  const { count } = useChronicle();

  return (
    <ChronicleSheet
      trigger={
        <button
          type="button"
          className="inline-flex items-center gap-1.5 rounded-sm border border-line bg-surface px-2.5 py-1.5 text-small font-semibold text-ink hover:border-accent hover:text-accent focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none"
        >
          {CHRONICLE.button}
          {count !== null && (
            <span className="rounded-full bg-accent-wash px-1.5 text-accent-deep tabular-nums">
              {formatCount(count)}
            </span>
          )}
        </button>
      }
    />
  );
}
